import LayoutHOC from '@landing_academy/shared/components-mantine/LayoutHOC';

import themeBase from './theme';


export const { theme, Layout, AppContext } = LayoutHOC({
  formContattoOpened: false,
  theme: themeBase,
});
